import { render, staticRenderFns } from "./CallLogStatisticTable.vue?vue&type=template&id=18db8e7a&"
import script from "./CallLogStatisticTable.vue?vue&type=script&lang=js&"
export * from "./CallLogStatisticTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports